import React from 'react';
import icons from '../assets/shinobi-sound-icons.png';

export function ShinobiSpeaker({muted}:{muted:boolean}) {
  // Clip each half explicitly so adjacent artwork cannot bleed into the icon.
  const x=muted?887:0;
  return <svg viewBox={`${x} 0 887 887`} width="100%" height="100%" aria-hidden="true" focusable="false" style={{display:'block',overflow:'hidden',pointerEvents:'none'}}>
    <svg x={x} y="0" width="887" height="887" viewBox={`${x} 0 887 887`} overflow="hidden"><image href={icons} width="1774" height="887"/></svg>
  </svg>;
}
